export const USER_SCROLL_INTENT_KEYS: Set<string> = new Set(['ArrowUp', 'Home', 'PageUp']);
